import { gql } from '@apollo/client';

export const CLAIM_BOOKING = gql`
  mutation ClaimBooking($value: ClaimBookingInput!) {
    claim(value: $value) {
      status
      noOfGuests
      booking {
        resID
        initialDate
        resStatus
        package {
          packageCode
          packageType
          fromDate
          toDate
        }
        guests {
          ageCategory
          clientGUID
          clientID
          gender
          guestAge
          guestID
          guestSeqN
          guestType
        }
      }
      sailors {
        clientId
        name {
          first
          last
        }
        email
        dob
        sex
        citizenship
      }
      reservationDetails {
        packageCode
        packageType
        fromDate
        toDate
        isMNVV
      }
    }
  }
`;
